import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
  ModalTrigger,
} from '@synoptic/ui-kit/modal/modal.js';
import { FC, ReactNode, useState } from 'react';
import { NewTournamentPostForm } from './new-tournament-post-form.tsx';

export type NewTournamentPostModalProps = {
  trigger: ReactNode;
  tournamentId: string;
};

export const NewTournamentPostModal: FC<NewTournamentPostModalProps> = ({
  trigger,
  tournamentId,
}) => {
  const [open, onOpenChange] = useState(false);

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalTrigger asChild>{trigger}</ModalTrigger>
      <ModalContent>
        <NewTournamentPostForm
          tournamentId={tournamentId}
          onSubmit={() => {
            onOpenChange(false);
          }}
          renderHeader={(title) => (
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
          )}
        />
      </ModalContent>
    </ModalRoot>
  );
};
